// Suitability: the routes and the sidebar rows of `wealth.onboarding.suitability` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.onboarding.suitability',
    routes: [
        {
            frontend: 'desk',
            path: 'suitability',
            lazy: () => import('@/pages/desk/suitability/page'),
        },
        {
            frontend: 'desk',
            path: 'suitability/assessment/:clientId',
            lazy: () => import('@/pages/desk/suitability/assessment/page'),
        },
        {
            frontend: 'desk',
            path: 'suitability/mandate/:clientId',
            lazy: () => import('@/pages/desk/suitability/mandate/page'),
        },
        {
            frontend: 'comply',
            path: 'suitability',
            lazy: () => import('@/pages/comply/suitability/page'),
        },
        // The read-only review of the Desk's assessment, opened
        // from the onboarding case that Comply must advance.
        {
            frontend: 'comply',
            path: 'suitability/assessment/:clientId',
            lazy: () => import('@/pages/comply/suitability/assessment/page'),
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'suitability',
            label: 'Assessments',
            href: '/comply/suitability',
            icon: 'Shield',
            group: 'consumer-duty',
            order: 220,
        },
        {
            frontend: 'desk',
            key: 'suitability',
            label: 'Suitability',
            href: '/desk/suitability',
            icon: 'Shield',
            group: 'advice-suitability',
            order: 420,
        },
    ],
});
